// extracted by mini-css-extract-plugin
export default {"icon":"webpack-concepts-Extraction-StudyList-ReferenceToggle-module__icon"};